<div
  mdbModal
  #modal="mdbModal"
  class="modal fade top lower-modal"
  id="frameModalTop"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ignoreBackdropClick: true}">
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body ">
        <div class="header">{{ (hasMultipleJobs ? Localization.FinishJobs : Localization.FinishJob) | translate }}</div>
        <div>{{ (hasMultipleJobs ? Localization.FinishJobsExplanation : Localization.FinishJobExplanation) | translate }}</div>
        <div class="job-feedback">
          <textarea class="job-feedback-text" matInput [rows]="10" [placeholder]="Localization.TypeReasons | translate"></textarea>
          <div class="d-flex flex-row justify-content-end mt-2">
            <i class="fas fa-paperclip icon" (click)="addFiles()" style="margin-right: 15px;"></i>
            <input type="file" accept='image/*' #file (change)="fileChangeEvent(true)"  style="display: none" multiple>
            <i class="fas fa-camera icon" (click)="openCamera()"></i>
            <input type="file" accept="image/*" #image (change)="fileChangeEvent(false)" style="display: none" multiple capture="environment">
          </div>
        </div>
        <div id="images-container" class="d-flex mb-2" style="overflow-x: auto;">
          <chapps-multimedium *ngFor="let multimedium of multimedia; index as i"
            class="ml-2 mr-2"
            [model]="multimedium"
            [deletable]="true"
            (deleted)="onPhotoDelete(i)"></chapps-multimedium>
        </div>
        <br />
      </div>
      <div class="modal-footer justify-content-between orange-text">
        <div (click)="hide()">{{ Localization.Cancel | translate }}</div>
        <div (click)="execute()">{{ Localization.Submit | translate }}</div>
      </div>
    </div>
  </div>
</div>
<chapps-multimedia-viewer></chapps-multimedia-viewer>
<chapps-image-cropper-modal (fileCropped)="fileCropped($event)"></chapps-image-cropper-modal>

